import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=20a80d77&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=20a80d77&prod&scoped=true&lang=css"
import style1 from "./Group.vue?vue&type=style&index=1&id=20a80d77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a80d77",
  null
  
)

export default component.exports